module.exports = __webpack_public_path__ + "img/longan-350x184.65e7b5a9.jpg";